import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/why-us-3.jpeg")